import { api } from '../configs/axiosConfigs';

export type TaxSettings = {
  annual_tax_rate: number;
};

export const getTaxSettings = async () => {
  return await api('/tax_settings');
};

export const updateTaxSettings = async (taxSettings: TaxSettings) => {
  return await api.put('/tax_settings', { tax_settings: taxSettings });
};
